var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-seo-wrapper"},[(typeof _vm.item[_vm.type] !== 'undefined')?_c('img',{attrs:{"src":_vm.item[_vm.type].data.find(el => el.type === _vm.typeImage).src,"alt":_vm.item[_vm.type].data.hasOwnProperty('seo') ?
     _vm.item[_vm.type].data.seo.data.hasOwnProperty('alterText') ?
     _vm.item[_vm.type].data.seo.data.alterText : '' : '',"title":_vm.item[_vm.type].data.hasOwnProperty('seo') ?
     _vm.item[_vm.type].data.seo.data.hasOwnProperty('title') ?
     _vm.item[_vm.type].data.seo.data.title : '' : ''}}):_c('img',{attrs:{"src":_vm.item.image.data.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }